export default __webpack_public_path__ + "static/media/pdf_Icon.03580dac.svg";